// Canonical presets for the vehicle sub-types shown in the route form and preferences.
// Every consumer (RouteForm, OrdersView, PreferencesDialog) reads from here so HERE
// always sees consistent truck dimensions for route calculation.

// axleCount e emissionType são essenciais para a HERE Tolls API classificar
// correctamente o veículo. Sem axleCount, HERE assume sempre 5+ eixos (a
// categoria mais cara, ex: Class M em FR) — inflava o custo das portagens
// até 50% em rotas longas. Sem emissionType, perdia o desconto EURO 6
// que vigora em França/Alemanha/Áustria (~15-20%).
//
// Defaults reflectem a realidade actual da indústria europeia:
//   · cisterna 40t / 18,75m → 5 eixos (3+2 articulada)
//   · frigorífico 26t / 13,6m → 4 eixos (3+1 carroçaria rígida)
//   · light_truck 7,5t → 2 eixos
//   · general_cargo 24t / 12m → 3 eixos
//   · car → não aplicável
//
// emissionType usa codes HERE: EURO_1..EURO_6. EURO_6 desde 2014 é
// obrigatório para HGV novos na UE → default razoável para frota
// moderna. Operador pode override no preset.
export const VEHICLE_PRESETS = {
  cisterna:      { vehicleType: 'hgv', truckWeight: '40',  truckHeight: '4.0', truckWidth: '2.55', truckLength: '18.75', truckAxleLoad: '11.5', truckAxleCount: '5', emissionType: 'EURO_6' },
  frigorifico:   { vehicleType: 'hgv', truckWeight: '26',  truckHeight: '4.0', truckWidth: '2.55', truckLength: '13.6',  truckAxleLoad: '10',   truckAxleCount: '4', emissionType: 'EURO_6' },
  light_truck:   { vehicleType: 'hgv', truckWeight: '7.5', truckHeight: '3.0', truckWidth: '2.2',  truckLength: '7.5',   truckAxleLoad: '5',    truckAxleCount: '2', emissionType: 'EURO_6' },
  general_cargo: { vehicleType: 'hgv', truckWeight: '24',  truckHeight: '4.0', truckWidth: '2.55', truckLength: '12.0',  truckAxleLoad: '10',   truckAxleCount: '3', emissionType: 'EURO_6' },
  car:           { vehicleType: 'car' },
};

// Build a full routeOptions patch for a given sub-type, optionally layering
// per-field overrides (e.g. admin values stored in client preferences).
export function buildPresetPatch(subType, overrides = {}) {
  const base = VEHICLE_PRESETS[subType];
  if (!base) return { ...overrides };
  const patch = { vehicleSubType: subType, ...base };
  ['truckWeight', 'truckAxleLoad', 'truckHeight', 'truckWidth', 'truckLength', 'truckAxleCount', 'emissionType'].forEach(k => {
    if (overrides[k] != null && overrides[k] !== '') patch[k] = String(overrides[k]);
  });
  return patch;
}

// Map raw vehicle category (Traccar / EcooGPS "type") → our sub-type.
// Falls back to null so the caller can decide (e.g. use client preferences).
export function subTypeFromVehicleCategory(rawCategory) {
  const t = (rawCategory || '').toString().toLowerCase();
  if (!t) return null;
  if (['car', 'sedan', 'hatchback', 'coupe', 'pickup', 'motorcycle'].includes(t)) return 'car';
  if (['van', 'lcv'].includes(t)) return 'light_truck';
  if (['truck', 'trailer', 'tractor', 'semitrailer'].includes(t)) return 'general_cargo';
  return null;
}
